/**
 * Viewport-gated deferred video — loads muted autoplay embeds when scrolled
 * into view (pattern from multicolumn-hover-video.js). Idempotent.
 */
(function hogViewportVideo() {
  'use strict';

  function pauseIframe(iframe) {
    if (!iframe || !iframe.contentWindow) return;
    try {
      if (iframe.classList.contains('js-youtube')) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      } else if (iframe.classList.contains('js-vimeo')) {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    } catch (e) {
      /* cross-origin */
    }
  }

  function bindViewportAutoplay(media) {
    if (!(media instanceof HTMLElement) || media.dataset.hogViewportBound === 'true') return;
    media.dataset.hogViewportBound = 'true';

    var hasLoaded = false;

    function loadAndPlay() {
      if (hasLoaded) return;
      hasLoaded = true;
      if (typeof media.loadContent === 'function') {
        media.loadContent(false);
      }
    }

    function pause() {
      pauseIframe(media.querySelector('iframe'));
      var video = media.querySelector('video');
      if (video) video.pause();
    }

    if (!('IntersectionObserver' in window)) {
      loadAndPlay();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadAndPlay();
          } else if (hasLoaded) {
            pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    observer.observe(media);
  }

  function init() {
    document.querySelectorAll('deferred-media[data-hog-viewport-autoplay]').forEach(bindViewportAutoplay);
  }

  function start() {
    if (customElements.get('deferred-media')) {
      init();
    } else {
      customElements.whenDefined('deferred-media').then(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
